import * as React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'
import useBreakpoint from '@utils/useBreakpoints'

interface Props {
  edl: EtatDesLieuxResponse
  onClick: () => void
  places: LocalisationResponse[]
  manifestation?: ManifestationResponse
  tenant?: Tenant
}

const EDLCard = ({ edl, onClick, places, manifestation, tenant }: Props) => {
  const i18n = useI18n()
  const [, currentBreakpoint] = useBreakpoint()
  const isPhone = currentBreakpoint === 'phone'

  const nameEvent = !!manifestation ? manifestation.libelle : !!tenant ? tenant.tenant.nomLocatairePermanent : ''

  const findPlaces = (ids: string[]) => {
    return ids
      .map((e) => {
        const findPlace = places.find((p) => p.id === e)

        if (!!findPlace) {
          return findPlace.libelle
        }

        return undefined
      })
      .filter(Boolean)
      .join(', ')
  }

  const renderMainInfos = () => {
    return (
      <SubInfos>
        {!isPhone && (
          <IconContainer>
            <Icon name="document" size={20} color={theme.colors.primary} />
          </IconContainer>
        )}
        <EventText primary>{i18n.t(`screens.edlList.${edl.type}`)}</EventText>
        <EventText>{i18n.t('screens.edlList.signatureDate', { date: new Date(edl.dateDeValidation) })}</EventText>
      </SubInfos>
    )
  }

  const renderRemainSpaces = () => {
    const placesName = findPlaces(edl.espaceIds)

    return (
      <SubInfos>
        <EventText numberOfLines={1}>{placesName}</EventText>
      </SubInfos>
    )
  }

  return (
    <Container key={edl.id} activeOpacity={0.9} onPress={onClick}>
      <SafeContainer>
        <TopContainer>
          {isPhone && (
            <IconContainer>
              <Icon name="document" size={20} color={theme.colors.primary} />
            </IconContainer>
          )}
          <Infos>
            <Name numberOfLines={2} ellipsizeMode="tail">
              {nameEvent}
            </Name>

            {renderMainInfos()}
            {renderRemainSpaces()}
          </Infos>

          {isPhone && (
            <IconContainer>
              <Icon name="arrow" size={20} color={theme.colors.primary} />
            </IconContainer>
          )}
        </TopContainer>
      </SafeContainer>
    </Container>
  )
}

export default EDLCard

const Container = styled(TouchableOpacity)`
  margin: 4px;
  border-radius: 8px;
  background-color: white;
  ${(props) => props.theme.breakpoint !== 'phone' && `width:360px;`}
  ${(props) => props.theme.constants.shadow};
`

const SafeContainer = styled(View)`
  border-radius: 8px;
  overflow: hidden;
  flex-direction: ${(props) => (props.theme.breakpoint === 'phone' ? 'row' : 'column')};
  ${(props) => props.theme.breakpoint === 'phone' && `align-items: center;`}
`

const TopContainer = styled(View)`
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? '16px' : '24px')};
  background-color: ${(props) => props.theme.colors.background};
  flex-direction: row;
  align-items: center;
  ${(props) => props.theme.breakpoint === 'phone' && `flex: 1;`}
`

const Name = styled(Text)<{ isList?: boolean }>`
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Body : props.theme.fonts.Headline)};
`

const EventText = styled(Text)<{ primary?: boolean; row?: boolean; padding?: boolean }>`
  ${(props) => !!props.padding && 'padding-right: 32px;'}
  ${(props) => !props.padding && !props.row && 'padding-right: 8px;'}
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) => (props.primary ? props.theme.colors.primary : props.theme.colors.secondaryText)};
`

const IconContainer = styled(View)`
  padding-right: 16px;
`

const Infos = styled(View)`
  flex: 1;
`

const SubInfos = styled(View)`
  flex-direction: row;
  padding-top: ${(props) => (props.theme.breakpoint === 'phone' ? '8' : '12')}px;
  align-items: center;
`
